import { ActionTree, MutationTree } from "vuex";
import NewsApi from "@/api/NewsApi";
import { handleCommonApiErrors } from "@/api/CommonApiErrorHandler";
import { Logger } from "@iloq/shared";
import { INews } from "@iloq/shared/INews";
import { LocallySearchableAsset, IRootState } from "@iloq/shared";
const newsApi = new NewsApi();

export interface INewsState {
  news: any[];
  blogposts: any[];
}

const initialState: INewsState = {
  news: [],
  blogposts: [],
};

const actions: ActionTree<INewsState, IRootState> = {
  fetchNews({ commit, dispatch, state }, languageCode: string): Promise<any> {
    return newsApi
      .fetchNews(languageCode)
      .then((data: INews[]) => {
        Logger.debug("NewsModule.fetchNews result:", JSON.stringify(data));
        const res: INews[] = data;
        if (res && (res as any).indexOf("No news found") >= 0) {
          commit("setNewsResults", undefined);
        } else {
          commit("setNewsResults", res);
          dispatch(
            "globalSearch/refreshData",
            {
              assetType: LocallySearchableAsset.news,
              assets: state.news.map((item) => ({
                ...item,
                wpDocType: LocallySearchableAsset.news,
              })),
            },
            { root: true },
          );
        }
      })
      .catch(handleCommonApiErrors);
  },
  fetchBlogPosts({ commit, dispatch, state }, languageCode: string): Promise<any> {
    return newsApi
      .fetchBlogPosts(languageCode)
      .then((data: INews[]) => {
        Logger.debug("NewsModule.fetchBlogPosts result:", JSON.stringify(data));
        const res: INews[] = data;
        if (res && (res as any).indexOf("No blog posts found") >= 0) {
          commit("setBlogPostsResults", undefined);
        } else {
          commit("setBlogPostsResults", res);
          dispatch(
            "globalSearch/refreshData",
            {
              assetType: LocallySearchableAsset.blogpost,
              assets: state.blogposts.map((item) => ({
                ...item,
                wpDocType: LocallySearchableAsset.blogpost,
              })),
            },
            { root: true },
          );
        }
      })
      .catch(handleCommonApiErrors);
  },
};

const mutations: MutationTree<INewsState> = {
  addNewsResult(state: INewsState, result: INews[]): void {
    state.news.unshift(result);
  },
  setNewsResults(state: INewsState, result: INews[]): void {
    state.news = result;
  },
  setBlogPostsResults(state: INewsState, result: INews[]): void {
    state.blogposts = result;
  },
};

export const newsModule = {
  actions,
  mutations,
  state: initialState,
  namespaced: true,
};
